import {
  DYNAMIC_COMPONENT_INIT,
  DYNAMIC_COMPONENT_INIT_WITH_STATE,
  DYNAMIC_COMPONENT_NAV_CHILD,
  DYNAMIC_COMPONENT_NAV_PARENT,
  DYNAMIC_COMPONENT_NAV_SIBLING_NEXT,
  DYNAMIC_COMPONENT_NAV_SIBLING_PREV,
  DYNAMIC_COMPONENT_SAVE_DATA,
  DYNAMIC_COMPONENT_NAV_NEXT,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_REQUEST,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_FAILURE,
  DYNAMIC_COMPONENT_NAV_SPECIFIC_LOCATION,
  DYNAMIC_COMPONENT_SAVE_DATA_BASED_TITLES,
  DYNAMIC_COMPONENT_SAVE_DATA_ERROR,
  DYNAMIC_COMPONENT_CLEAN_DATA,
  SAVE_ENTITY_DATA,
  CLEAR_ENTITY_DATA,
  TRIGGER_DIRTY_MAP,
  VALIDATE_CONFIG_RULES_RUNNING,
  VALIDATE_CONFIG_RULES_FINISHED,
  SET_VALIDATION_CONFIGURATION,
  SAVE_SECTION_STATUSES,
  UPDATE_VERSION,
  SAVING_NETWORK_ERROR,
  CLEAR_DYNAMIC_COMPONENT,
  API_PANEL_SCORES_POST_FAILURE,
  AUTOSAVE_SUCCESS,
  AUTOSAVE_REQUEST,
  QUEUE_SAVE,
  DYNAMIC_COMPONENT_FIN_HOLDING_EXCEEDS_FED_SHARE,
  COLLABORATION_LOCK_CHANGE,
  COLLABORATION_REMOTE_DOCUMENT_UPDATE,
  COLLABORATION_ENTER_ROOM,
  COLLABORATION_TOGGLE_COLLABORATION,
  COLLABORATION_ROOM_LEFT,
  COLLABORATION_CLOSE_ALL_ROOMS,
  COLLABORATION_INIT_WITH_STATE_PROXY,
} from 'common/types';
import {
  getUpdatedReduxStatePayload,
  getUpdatedReduxState,
  removeDataFromReduxState,
  checkIfIncludedsIn,
} from 'common/utils';
import {TASK_ACTION_HANDLERS} from 'go/reducers/tasks';
import {evalDependentDataRules} from 'framework/validation/evalDependentDataRules';
import {APPLICATION_LINK_ACTION_HANDLERS} from 'go/reducers/applicationLinkData';
import _ from 'lodash';
import produce, {original} from 'immer';
import {LOCATION_CHANGE} from 'react-router-redux';

import {isAttachment} from 'framework/collaboration/collaboration.utils';

const initialState = {
  currentLocation: '',
  data: {}, //TODO: to remove all v1 keys
  dataCopy: {},
  dataErrors: {},
  validationErrors: {isLoading: true},
  config: {},
  context: {},
  serviceCall: () => {},
  savaData: () => {},
  dataBasedTitles: [],
  sectionStatuses: {},
  networkErrors: {},
};

const initialStateCopy = _.cloneDeep(initialState);

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [DYNAMIC_COMPONENT_INIT]: (state, action) => {
    return produce(state, (draft) => {
      const {config, data, serviceCall} = action;
      draft.config = config;
      draft.data = data;
      draft.dataErrors = {};
      draft.sessionData = {};
      draft.validationErrors = {isLoading: true};
      draft.validationDirtyMap = {};
      draft.dataCopy = JSON.parse(JSON.stringify(draft.data));
      draft.serviceCall = serviceCall;
      draft.currentLocation = '';
      draft.context = {};
      draft.dataBasedTitles = [];
      draft.isConcurrencyModalActive = false;
      draft.networkErrors = {};
    });
  },
  [DYNAMIC_COMPONENT_INIT_WITH_STATE]: (state, action) => {
    return produce(state, (draft) => {
      const {initState} = action;
      draft.dataErrors = {};
      draft.validationErrors = {isLoading: true};
      draft.validationDirtyMap = {};
      draft.dataCopy = JSON.parse(JSON.stringify(_.get(initState, 'data', {})));
      draft.currentLocation = '';
      draft.context = {};
      draft.dataBasedTitles = [];
      draft.isConcurrencyModalActive = false;
      draft.networkErrors = {};
      _.unset(
        draft,
        `collaboration.rooms.${_.get(initState, 'data.entityId')}.initState`
      );
      _.assign(draft, initState);
    });
  },
  [DYNAMIC_COMPONENT_NAV_CHILD]: (state, action) => {
    return produce(state, (draft) => {
      let {currentLocation} = draft;
      draft.currentLocation = getChild(currentLocation, action.index);
    });
  },
  [DYNAMIC_COMPONENT_NAV_PARENT]: (state, action) => {
    return produce(state, (draft) => {
      let {currentLocation} = draft;
      draft.currentLocation = getParent(currentLocation);
    });
  },
  [DYNAMIC_COMPONENT_NAV_SIBLING_NEXT]: (state, action) => {
    return produce(state, (draft) => {
      let {currentLocation} = draft;
      let index = getLastIndex(currentLocation);
      draft.currentLocation = getSibling(currentLocation, index + 1);
    });
  },
  [DYNAMIC_COMPONENT_NAV_SIBLING_PREV]: (state, action) => {
    return produce(state, (draft) => {
      let {currentLocation} = draft;
      let index = getLastIndex(currentLocation);
      draft.currentLocation = getSibling(currentLocation, index - 1);
    });
  },
  [DYNAMIC_COMPONENT_NAV_SPECIFIC_LOCATION]: (state, action) => {
    return produce(state, (draft) => {
      const {currentLocation} = draft;
      draft.currentLocation = action.specificLocation;
      evalDependentDataRules(draft, 'currentLocation', undefined, currentLocation);
    });
  },
  [DYNAMIC_COMPONENT_NAV_NEXT]: (state, action) => {
    return produce(state, (draft) => {
      const {currentLocation, config, dataBasedTitles} = draft;

      if (currentLocation !== '') {
        let currentObject =
          _.get(config.payload, currentLocation) ||
          (config.contents && _.get(config.contents[0], location, ''));

        //Need to check all children cause they might be data driven
        let location = getChild(currentLocation, 0);
        let child =
          _.get(config.payload, location) ||
          (config.contents && _.get(config.contents[0], location, ''));
        let childType = child ? child.type : undefined;
        if (childType !== undefined && currentObject.navToChildren) {
          if (child.dataBasedNav === undefined || config.skipNavNextSubNav) {
            draft.currentLocation = location;
            return;
          } else {
            let i = 0;
            while (child) {
              if (checkIfIncludedsIn(dataBasedTitles, child.title)) {
                draft.currentLocation = location;
                return;
              }
              location = getChild(currentLocation, ++i);
              child =
                _.get(config.payload, location) ||
                (config.contents && _.get(config.contents[0], location, ''));
            }
          }
        }
        const currentIndex = getLastIndex(currentLocation);
        //Need to check all of sibs because they might have dynamic data
        location = getSibling(currentLocation, currentIndex + 1);
        let sib =
          _.get(config.payload, location) ||
          (config.contents && _.get(config.contents[0], location, ''));
        let sibType = sib ? sib.type : undefined;

        if (sibType !== undefined) {
          if (sib.dataBasedNav === undefined) {
            draft.currentLocation = location;
            return;
          } else {
            let i = currentIndex + 1;
            location = getSibling(currentLocation, i);
            sib =
              _.get(config.payload, location) ||
              (config.contents && _.get(config.contents[0], location, ''));
            while (sib) {
              if (checkIfIncludedsIn(dataBasedTitles, sib.title)) {
                draft.currentLocation = location;
                return;
              }
              location = getSibling(currentLocation, ++i);
              sib =
                _.get(config.payload, location) ||
                (config.contents && _.get(config.contents[0], location, ''));
            }
          }
        }

        location = getParent(currentLocation);

        if (location !== '') {
          let parentIndex = getLastIndex(location);
          location = getSibling(location, parentIndex + 1);
          let parType =
            getSpotType(config.payload, location) ||
            (config.contents && _.get(config.contents[0], location, ''));
          if (parType !== undefined) {
            draft.currentLocation = location;
            return;
          }
        }
      } else {
        draft.currentLocation = 'contents[0]';
        return;
      }

      draft.currentLocation = '';
      return;
    });
  },
  [DYNAMIC_COMPONENT_SAVE_DATA]: (state, action) => {
    return produce(state, (draft) => {
      const {dataPath, componentData} = action;
      if (action.dataPath === 'scorePanelData') {
        const transformedData = [...draft.data, componentData];
        const data = getUpdatedReduxStatePayload(draft.data, dataPath, transformedData);
        let result = [];
        let found = {};
        for (let i = data.payload.scorePanelData.length - 1; i >= 0; i--) {
          const current = data.payload.scorePanelData[i];
          if (!found[current.scoreId]) {
            result.push(current);
            found[current.scoreId] = true;
          }
        }
        result = _.reverse(_.filter(result, 'scoreId'));
        draft.data = result;
      } else {
        draft.data = getUpdatedReduxStatePayload(draft.data, dataPath, componentData);
      }
      const newDataPath = `data.payload.${dataPath}`;
      evalDependentDataRules(
        draft,
        newDataPath,
        action.extraProps,
        _.get(state, newDataPath)
      );
    });
  },
  [DYNAMIC_COMPONENT_FIN_HOLDING_EXCEEDS_FED_SHARE]: (state, action) => {
    return produce(state, (draft) => {
      const {dataPath, componentData} = action;
      const newDataPath = dataPath + '.fedShareAmountExceeded';
      getUpdatedReduxState(draft, newDataPath, componentData);
    });
  },
  [DYNAMIC_COMPONENT_SAVE_DATA_ERROR]: (state, action) => {
    return produce(state, (draft) => {
      const {dataPath, errors} = action;
      draft.dataErrors = getUpdatedReduxStatePayload(draft.dataErrors, dataPath, errors);
    });
  },
  [DYNAMIC_COMPONENT_CLEAN_DATA]: (state, action) => {
    return produce(state, (draft) => {
      draft.dataCopy = JSON.parse(JSON.stringify(draft.data));
    });
  },
  [DYNAMIC_COMPONENT_DEPENDENCY_GET_REQUEST]: (state, action) => {
    return produce(state, (draft) => {
      let context = {
        ...draft.context,
      };
      context[action.meta.objectType] = {loading: true};
      draft.context = context;
    });
  },
  [DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS]: (state, action) => {
    return produce(state, (draft) => {
      let numDepsSuccessful = _.get(draft, 'context.numLoadedSuccessfully', 0);
      if (!action.meta.optional) numDepsSuccessful += 1;

      let context = {
        ...draft.context,
        numLoadedSuccessfully: numDepsSuccessful,
      };
      if (action.meta.inPayloadObj) {
        context[action.meta.objectType] = {payload: action.payload, loading: false};
      } else {
        context[action.meta.objectType] = {...action.payload, loading: false};
      }
      draft.context = context;
    });
  },
  [DYNAMIC_COMPONENT_DEPENDENCY_GET_FAILURE]: (state, action) => {
    return produce(state, (draft) => {
      let context = {
        ...draft.context,
      };
      if (_.get(action, 'payload.status') === 404) {
        let numDepsSuccessful = _.get(draft, 'context.numLoadedSuccessfully', 0);
        if (!action.meta.optional) numDepsSuccessful += 1;
        context = {
          ...context,
          numLoadedSuccessfully: numDepsSuccessful,
        };
      }
      context[action.meta.objectType] = {
        fetchError: action.payload,
        loading: false,
      };
      draft.context = context;
    });
  },
  [DYNAMIC_COMPONENT_SAVE_DATA_BASED_TITLES]: (state, action) => {
    return produce(state, (draft) => {
      draft.dataBasedTitles = action.dataBasedTitles;
    });
  },
  [UPDATE_VERSION]: (state, action) => {
    return produce(state, (draft) => {
      const {dataPath, data, modifiedBy, isConcurrencyModalActive, modifyDate} = action;

      getUpdatedReduxState(draft, dataPath, data);
      draft.isConcurrencyModalActive = isConcurrencyModalActive;
      draft.modifiedBy = modifiedBy;
      draft.modifyDate = modifyDate;
      draft.savingData = false;
    });
  },
  [SAVE_ENTITY_DATA]: (state, action) => {
    return produce(state, (draft) => {
      if (action.saveMany) {
        const dataPaths = action.dataPath;
        const values = action.data;
        _.forEach(dataPaths, (path, index) => {
          const prevData = _.get(draft, _.get(dataPaths, index));
          getUpdatedReduxState(draft, _.get(dataPaths, index), _.get(values, index));
          evalDependentDataRules(
            draft,
            _.get(dataPaths, index),
            action.extraProps,
            prevData
          );
        });
      } else {
        const prevData = _.get(draft, action.dataPath);
        getUpdatedReduxState(draft, action.dataPath, action.data);
        evalDependentDataRules(draft, action.dataPath, action.extraProps, prevData);
      }

      const currentlyCollaborating = !!_.get(draft, 'collaboration.roomList'); // autosaving will be handled by CE server

      if (action.entityType && !currentlyCollaborating) {
        draft.pendingSave = true; // indicates that an autosave is about to happen, needed for the submit button to disable immediatly
      }

      if (action.fieldPath) {
        _.setWith(
          draft,
          `validationDirtyMap.${action.fieldPath}`,
          true,
          Object // otherwise numbers in the path are treated as array creation
        );
      }
    });
  },
  [AUTOSAVE_SUCCESS]: (state, action) => {
    return produce(state, (draft) => {
      if (_.get(action, 'meta.entityType') === 'riskAssessment') {
        draft.context.riskAssessment[0] = draft.context.riskAssessment[0]
          ? draft.context.riskAssessment[0]
          : {};
        draft.context.riskAssessment[0].riskAssessmentId =
          action.payload.riskAssessmentId;
      }
      if (_.get(action, 'meta.entityType') === 'panelReview') {
        let formattedScores = [];
        let scores = _.get(action, 'payload') ? _.get(action, 'payload') : [];
        _.forEach(scores, (score) => {
          let scoreId = _.get(score, 'scoreId');
          let noScoreId = _.omit(score, 'scoreId');
          let scoreObj = {...scoreId, ...noScoreId};
          formattedScores.push(scoreObj);
        });
        _.forEach(formattedScores, (score) => {
          _.forEach(draft.context.panelReviewUserScoresV2.payload, (draftScore) => {
            if (
              draftScore.partId == score.partId &&
              draftScore.factor == score.factor &&
              draftScore.part == score.part
            ) {
              (draftScore.version = score.version),
                (draftScore.modifyDate = score.modifyDate),
                (draftScore.entryDate = score.entryDate);
            }
          });
        });
      }
      draft.savingData = false;
    });
  },
  [AUTOSAVE_REQUEST]: (state, action) => {
    return produce(state, (draft) => {
      draft.pendingSave = false;
      draft.savingData = true;
      draft.debouncedSave = _.filter(
        draft.debouncedSave,
        (entityType) => _.get(action, 'meta.entityType') !== entityType
      );
    });
  },
  [QUEUE_SAVE]: (state, action) => {
    return produce(state, (draft) => {
      draft.debouncedSave = _.uniq([...draft.debouncedSave, action.entityType]);
    });
  },
  [CLEAR_ENTITY_DATA]: (state, action) => {
    return produce(state, (draft) => {
      let updatedState = removeDataFromReduxState(draft, action.dataPath);
      if (action.validationId) {
        updatedState = removeDataFromReduxState(
          updatedState,
          `validationDirtyMap.${action.validationId}`
        );
      }
    });
  },
  [TRIGGER_DIRTY_MAP]: (state, action) => {
    return produce(state, (draft) => {
      if (action.fieldPath) {
        draft = _.setWith(
          draft,
          `validationDirtyMap.${action.fieldPath}`,
          true,
          Object // otherwise numbers in the path are treated as array creation
        );
      }
    });
  },
  [VALIDATE_CONFIG_RULES_RUNNING]: (state, action) => {
    return produce(state, (draft) => {
      getUpdatedReduxState(draft, 'validationErrors.isLoading', true);
    });
  },
  [SET_VALIDATION_CONFIGURATION]: (state, action) => {
    return produce(state, (draft) => {
      const rules = action.rules;
      getUpdatedReduxState(draft, 'validationErrors.overrideValidations', rules);
    });
  },
  [VALIDATE_CONFIG_RULES_FINISHED]: (state, action) => {
    return produce(state, (draft) => {
      const validationObject = {
        ..._.get(draft, 'validationErrors', {}),
        isLoading: false,
        submissionAttempted: _.get(draft, 'validationErrors.submissionAttempted', false),
        allValid: action.allValid,
        errors: action.results,
      };
      getUpdatedReduxState(draft, 'validationErrors', validationObject);
    });
  },
  [SAVE_SECTION_STATUSES]: (state, action) => {
    // Leaving the path as sectionsStatus so we don't have to change configs:
    return produce(state, (draft) => {
      getUpdatedReduxState(draft, 'sectionsStatus', action.sectionStatuses);
    });
  },
  [SAVING_NETWORK_ERROR]: (state, action) => {
    return produce(state, (draft) => {
      const errorObj = {
        hasError: true,
        error: action.error,
      };
      getUpdatedReduxState(draft, 'networkErrors.saveEntitySaga', errorObj);
    });
  },
  [API_PANEL_SCORES_POST_FAILURE]: (state, action) => {
    return produce(state, (draft) => {
      const errorObj = {
        hasError: true,
        error: action.error,
      };
      getUpdatedReduxState(draft, 'networkErrors.panelReviewV2', errorObj);
    });
  },
  [CLEAR_DYNAMIC_COMPONENT]: (state, action) => {
    return {};
  },
  [COLLABORATION_ROOM_LEFT]: (state, action) => {
    return produce(state, (draft) => {
      _.unset(draft, `collaboration.rooms.${action.roomName}`);
      let newRoomList = _.sortBy(
        Object.keys(_.get(draft, 'collaboration.rooms', {}))
      ).join(',');
      if (newRoomList !== _.get(draft, 'collaboration.roomList')) {
        _.set(draft, 'collaboration.roomList', newRoomList);
      }
    });
  },
  [COLLABORATION_CLOSE_ALL_ROOMS]: (state, action) => {
    return produce(state, (draft) => {
      _.set(draft, `collaboration.rooms`, {});
      _.set(draft, `collaboration.roomList`, '');
    });
  },
  [COLLABORATION_TOGGLE_COLLABORATION]: (state, action) => {
    return produce(state, (draft) => {
      draft.collaboration = draft.collaboration || {};
      _.assign(draft.collaboration, action);
    });
  },
  [COLLABORATION_ENTER_ROOM]: (state, action) => {
    return produce(state, (draft) => {
      if (!action.isDependency) {
        // clear rooms
        _.set(draft, `collaboration.rooms`, {});
      }
      // set up the room config
      _.set(draft, `collaboration.rooms.${action.roomName}`, action);
      _.set(
        draft,
        `collaboration.rooms.${action.roomName}.enteredAtPathName`,
        _.get(draft, 'collaboration.currentPathName')
      );
      // set up that we are loading the room
      const storePath = _.get(action, 'storePath');
      if (!action.cancelReset) {
        _.set(draft, storePath, {loading: true});
      }

      let newRoomList = _.sortBy(
        Object.keys(_.get(draft, 'collaboration.rooms', {}))
      ).join(',');
      if (newRoomList !== _.get(draft, 'collaboration.roomList')) {
        _.set(draft, 'collaboration.roomList', newRoomList);
      }
    });
  },
  [COLLABORATION_LOCK_CHANGE]: (state, action) => {
    return produce(state, (draft) => {
      const {cwAction} = action;
      _.set(draft, `collaboration.rooms.${cwAction.roomName}.lockInfo`, cwAction.payload);
    });
  },
  [COLLABORATION_REMOTE_DOCUMENT_UPDATE]: (state, action) => {
    return produce(state, (draft) => {
      const {cwAction} = action;
      let newdocument = _.get(cwAction, 'payload');
      let roomName = _.get(cwAction, 'roomName', '');
      if (_.isEmpty(newdocument) && !isAttachment(roomName)) {
        _.set(draft, 'collaboration.error', 'empty state from remote');
        return;
      }
      let roomConfig = _.get(draft, `collaboration.rooms.${cwAction.roomName}`);
      if (!roomConfig) {
        _.set(draft, 'collaboration.error', 'remote update from unknown room');
        return;
      }
      let wasLoading = _.get(draft, `${roomConfig.storePath}.loading`);
      if (wasLoading) {
        _.unset(draft, `${roomConfig.storePath}.loading`);
      }
      if (wasLoading && roomConfig.isDependency && !roomConfig.isOptional) {
        let numDepsSuccessful = _.get(draft, 'context.numLoadedSuccessfully', 0);
        numDepsSuccessful += 1;
        _.set(draft, 'context.numLoadedSuccessfully', numDepsSuccessful);
      }
      if (roomConfig.inPayloadObj) {
        _.set(draft, `${roomConfig.storePath}.payload`, newdocument);
      } else {
        _.set(draft, roomConfig.storePath, newdocument);
      }
      // todo: are any reducers storing things in session?
      // todo: are any reducers updating sister objects that are not syncd?
      // todo: sync validationDirtyMap from remote? see rant
    });
  },
  [COLLABORATION_INIT_WITH_STATE_PROXY]: (state, action) => {
    return produce(state, (draft) => {
      const {initState} = action;
      draft.dataErrors = {};
      draft.validationErrors = {isLoading: true};
      draft.validationDirtyMap = {};
      draft.dataCopy = JSON.parse(JSON.stringify(_.get(initState, 'data', {})));
      draft.currentLocation = '';
      draft.context = {};
      draft.dataBasedTitles = [];
      draft.isConcurrencyModalActive = false;
      draft.networkErrors = {};
      _.assign(draft, initState);
    });
  },
  [LOCATION_CHANGE]: (state, action) => {
    return produce(state, (draft) => {
      _.set(
        draft,
        'collaboration.previousPathName',
        _.get(draft, 'collaboration.currentPathName')
      );
      _.set(draft, 'collaboration.currentPathName', _.get(action, 'payload.pathname'));
    });
  },
  ...TASK_ACTION_HANDLERS,
  ...APPLICATION_LINK_ACTION_HANDLERS,
};

const getSpotType = (payload, location) => {
  let spot = _.get(payload, location);
  return spot ? spot.type : undefined;
};
const getChild = (currentLocation, index) => {
  currentLocation += (currentLocation === '' ? '' : '.') + `contents[${index}]`;
  return currentLocation;
};

const getParent = (currentLocation) => {
  return currentLocation.substr(0, currentLocation.lastIndexOf('.'));
};

const getLastIndex = (currentLocation) => {
  let match = currentLocation.match(/\d+/g);
  return parseInt(match[match.length - 1], 10);
};

const getSibling = (currentLocation, index) => {
  currentLocation = getParent(currentLocation);
  return getChild(currentLocation, index);
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
